var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 5.86667C16.4 9.1015 13.7682 11.7333 10.5333 11.7333C7.2985 11.7333 4.66667 9.1015 4.66667 5.86667C4.66667 2.63184 7.2985 0 10.5333 0C13.7682 0 16.4 2.63184 16.4 5.86667ZM6.79863 12.4889C3.27627 13.9913 1 17.4374 1 21.2667C1 21.672 1.32835 22 1.73333 22M19.3333 22C19.7383 22 20.0667 21.672 20.0667 21.2667C20.0667 17.4374 17.7904 13.9913 14.268 12.4889C14.0754 12.4058 13.8573 12.4101 13.6693 12.4996C11.6835 13.4292 9.3832 13.4292 7.39733 12.4996C7.20863 12.4101 6.99056 12.4058 6.79863 12.4889C3.27627 13.9913 1 17.4374 1 21.2667C1 21.672 1.32835 22 1.73333 22H19.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA1);
export default __webpack_public_path__ + "static/media/a1.666d7b99b892e6e7486caf01def4e29b.svg";
export { ForwardRef as ReactComponent };